import React from "react";

import styles from "./Section6.module.scss";

export const Section6 = function () {
  return (
    <section id="conveners-section" className={`${styles.section6Wrapper} cc--component-container`}>
      <h3>Your Course Convenor</h3>
      <div className={styles.section6Container}>
        <div className={styles.section6Content}>
          <div className={styles.image} />
          <div className={styles.name}>
            <p>Eric Rosenbach</p>
            <p>
              <em>Co-Director, Belfer Center for Science and International Affairs, Harvard Kennedy School</em>
            </p>
          </div>
          <div className={styles.summary}>
            <p>
              Eric Rosenbach served as Chief of Staff to Secretary of Defense Ash Carter from 2015-2017. He advised on
              war strategy against ISIS, the Asia ‘rebalance’, and efforts to counter Russian aggression. Rosenbach led
              initiatives to improve innovation, including the Defense Digital Service and the Defense
              Innovation&nbsp;Board.
            </p>
            <p>
              Before his role as Chief of Staff, Rosenbach was Assistant Secretary of Defense, responsible for cyber
              strategy and countering threats from Iran, North Korea, and China. He also worked at Harvard Kennedy
              School, advising on cyber and counterterrorism while leading the Belfer Center for Science and
              International Affairs. With a background as an army intelligence officer and commander, his unit was
              recognized as the top intelligence organization in the U.S. Military. Rosenbach is an author and
              contributor to major publications. He holds a Juris Doctor, a Master&rsquo;s of Public Policy, and a
              Bachelor&nbsp;of&nbsp;Arts.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
